"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraInfoBox = void 0;
const react_1 = __importDefault(require("react"));
const Icons_1 = require("./Icons");
require("../styles/eura-info-box.css");
const EuraInfoBox = (props) => {
    var _a;
    const iconSize = props.size || '1em';
    const typeClasses = {
        info: props.secondary ? 'eura-info-box-icon__info-secondary' : 'eura-info-box-icon__info',
        error: 'eura-info-box-icon__error',
        alert: 'eura-info-box-icon__alert',
        success: 'eura-info-box-icon__success',
    };
    const typeIcons = {
        info: react_1.default.createElement(Icons_1.InfoIcon, { width: iconSize, height: iconSize }),
        error: react_1.default.createElement(Icons_1.TriangleErrorIcon, { width: iconSize, height: iconSize }),
        alert: react_1.default.createElement(Icons_1.AlertIcon, { width: iconSize, height: iconSize }),
        success: react_1.default.createElement(Icons_1.CheckmarkIcon, { width: iconSize, height: iconSize }),
    };
    const classNames = ['eura-info-box', typeClasses[props.type || 'info'], (_a = props.className) !== null && _a !== void 0 ? _a : ''];
    const role = props.role ? props.role : 'document';
    return (react_1.default.createElement("div", { className: classNames.join(' '), role: role, "data-testid": props.dataTestId, tabIndex: props.tabIndex },
        react_1.default.createElement("div", { className: 'eura-info-box-icon' }, props.icon ? props.icon : typeIcons[props.type || 'info']),
        react_1.default.createElement("div", { className: 'eura-info-box-text' }, props.text ? props.text : props.children)));
};
exports.EuraInfoBox = EuraInfoBox;
